export default "__VITE_ASSET__ClWNzMFJ__"